import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@bufferapp/ui';
import CheckmarkIcon from '@bufferapp/ui/Icon/Icons/Checkmark';

function BulletPoint(props) {
  const { text } = props;

  return (
    <li>
      {' '}
      <CheckmarkIcon size="medium" />
      <Text>{text}</Text>
    </li>
  );
}

BulletPoint.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BulletPoint;
